import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex justify-center items-center">
          <div className="text-gray-500 text-sm text-center">
            © {new Date().getFullYear()} توازن. جميع الحقوق محفوظة
          </div>
        </div>
      </div>
    </footer>
  );
};
